<template>
    <div>
		<div v-if="parseInt(get_user.profile.total_deposit) > 0">
			<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleLev)">
				<app-twofa  :call_from="request_page"></app-twofa>
			</div>
			<div v-else>
				<div class="mainTitle text-center mt-4 mb-3"> 
					<h3 class="mb-4" v-if="!congModuleLev"> {{ $t('getSubPlan') }}</h3>
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
				</div> 
				<!--loader - message---> 
				<!------------------request form-------------------------> 
				<div class="partcipate-fund CustomBlockWidth inMiddle-area mb-3" v-if="transaction_id == '' && !congModuleLev && subPlanDetail != ''">
					<div class="whitebox p-4 mb-3" > 
						<div class="selectPlan mb-3">
							<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
								<h4>{{subPlanDetail[0].plan_type}}</h4>
								<div class="price" >
									&euro; {{planDetailData.amount}} {{ $t('mnth') }}
								</div>
							</div>
						</div>
						<div class="selectPlan mb-3" v-if="coupon_apply">
							<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
								<h4 class="d-flex align-items-center">{{$t('applyCouponCode')}} 
									<div class="couponapplied ml-2">
										<div class="appliedcouponcode">
											<span>{{coupon_code1}}</span>
										</div>
									</div>
								 </h4>
								<div class="price" >
									&euro; {{coupon_price}}
								</div> 
							</div>
							<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
								<h4>{{$t('TotalAmount')}}</h4>
								<div class="price">
									&euro; {{amount}}
								</div>
							</div>
						</div>
						 
						<!-------------------have a promocode section---------------------------------------------->
						<div class="promocode d-flex align-items-center justify-content-start" v-else>   
							<!--<div class="couponapplied" v-if="couponapplied">
								<div class="appliedcouponcode">
									<span>{{coupon_code}}</span>
									<span>{{counpon_price2}}</span>
									<span>{{amount}}</span>
									<feather type="x" @click="applycoupon('','remove')" v-if="couponapplied"></feather>
								</div>
								<div class="appliedcoupon">
									<p>{{coupon_code}}  {{ $t('appliedmnth') }}</p>
								</div> 
							</div> -->
							<div class="selectPlan mb-3 w-100" v-if="couponapplied">
								<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
									<h4 class="d-flex align-items-center">{{$t('applyCouponCode')}} 
										<div class="couponapplied ml-2">
											<div class="appliedcouponcode">
												<span>{{coupon_code}}</span>
												<feather type="x" @click="applycoupon('','remove')" v-if="couponapplied" size="1em"></feather>
											</div>
										</div>
									 </h4>
									<div class="price" >
										&euro; {{counpon_price2}}
									</div> 
								</div>
								<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
									<h4>{{$t('TotalAmount')}}</h4>
									<div class="price">
										&euro; {{amount}}
									</div>
									
								</div>
							</div>
							<a class="haveacode" v-else href="#" v-on:click.prevent="show_coupon_list=true; getcouponList() ; coupon_code_validity = ''"> {{ $t('havePromoCode') }}</a> 
						</div> 
						<!---------------------------------------------------------------------------------------->
					</div>
					<div class="mb-3" >
						<p> {{$t('deducedMonthlySubscription')}} </p> 
					</div>
					<div class="whitebox mb-3 p-4"> 
						<div class="form-group field-wrapper">
							<div class="customSelect mdb-select md-form float-field form-control" @click="selectAccount = !selectAccount" :class="(selectAccount?'active' : '')">
								<div class="SelectAcntList">
									<div class="d-flex align-items-center justify-content-between" v-if="account_id == ''">
									<p> {{ $t('selectAccountId') }}</p></div>
									<div class="d-flex align-items-center justify-content-between" v-else>
										<span>
											<img :src="'../../../../static/fxView/images/'+platformIcon[platform]" class="mr-2" alt="Icon">
											{{account_id}} 
										</span>
										<small v-html="(parseInt(demo_live) == 1)? $t('live') : $t('demo') "></small>
									</div>
								</div>
								<ul class="scrollbar" ><!---->
									<li v-for="(list,key) in tradingAccountList.records" v-if="parseInt(list.demo_live) == 1" @click="asignValueParentComponent(list)" >
										<div class="aclist" > 
											<span>
												<img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" class="mr-2"  alt="Icon"> {{list.account_id}}  
											</span>
											<small v-html="(parseInt(list.demo_live) == 1)? $t('live') : $t('demo') "></small>
										</div>
									</li>
								</ul>
							</div>
							<input type="hidden" v-model="account_id"  v-validate="{ required: true }" name="account_id" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('account_id') }" ref="account_idInput" required>
							<ul><li v-for="error in errors.collect('account_id')" class="error">{{$t('fieldReq')}}</li></ul>
						</div> 
						<div class="mb-3" >
							<p> {{ $t('noteUnsubTool') }}</p>
						</div>
						<div class="clearfix"></div> 
						<div class="text-center d-flex align-items-center justify-content-between"> 
							<div class="form-group field-wrapper mb-0">
		                        <label class="text-left fancy_radiochk_btn mb-0"> {{$t('clickToAgree')}} <a href="../../../../static/fxView/pdf/FXVIEW_VPS_T&C.pdf" target="_blank">{{$t('vpsTC')}}</a>
		                            <input type="checkbox" v-model="agree1" value="1"  v-validate="{ required: true }" name="agree1" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('agree1') }" ref="agree1Input" required><span class="checkmark"></span>
									<ul><li v-for="error in errors.collect('agree1')" class="error">{{$t('fieldReq')}}</li></ul>
		                        </label>
		                    </div>
							<button class="prism_btn btn_sm" v-on:click="submitChangeLeverageRequestOtp()"> {{ $t('Subscribe') }}</button> 
						</div> 
					</div>
					 
				</div> 
				<!----------------------------------------------------->
				<div class="partcipate-fund CustomBlockWidth whitebox inMiddle-area p-4 mb-3" v-if="transaction_id != '' && !congModuleLev">
					<div v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 1)">
						<div class="whitebox p-4 mb-3" >  
							<div class="selectPlan mb-3">
								<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
									<h4>{{subPlanDetail[0].plan_type}}</h4>
									<div class="price" >
										&euro; {{planDetailData.amount}}{{ $t('mnth') }}
									</div>
								</div>
							</div> 
							
							<div class="selectPlan mb-3" v-if="coupon_apply">
								<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
									<h4 class="d-flex align-items-center">{{$t('applyCouponCode')}} 
										<div class="couponapplied ml-2">
											<div class="appliedcouponcode">
												<span>{{coupon_code1}}</span>
											</div>
										</div>
									 </h4>
									<div class="price" >
										&euro; {{coupon_price}}
									</div> 
								</div>
								<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
									<h4>{{$t('TotalAmount')}}</h4>
									<div class="price">
										&euro; {{amount}}
									</div>
								</div>
							</div>
							
							<div class="promocode d-flex align-items-center justify-content-start" v-else> 
								<div class="selectPlan w-100 mb-3" v-if="couponapplied">
									<div class="border-bottom d-flex align-items-center justify-content-between pb-3 mb-3">
										<h4 class="d-flex align-items-center">{{$t('applyCouponCode')}}
											<div class="couponapplied ml-2">
												<div class="appliedcouponcode">
													<span>{{coupon_code}} <feather type="x" @click="applycoupon('','remove')" v-if="couponapplied"  size="1em"></feather></span>
												</div>
											</div>
										 </h4>
										<div class="price" >
											&euro; {{counpon_price2}}
										</div> 
									</div>
									<div class="border-bottom d-flex align-items-center justify-content-between pb-3">
										<h4>{{$t('TotalAmount')}}</h4>
										<div class="price">
											&euro; {{amount}}
										</div>
										
									</div>
								</div>
								<!--<div class="couponapplied" >
									<div class="appliedcouponcode">
										<span>{{}}</span>
										
									</div>
									<div class="appliedcoupon">
										<p>{{coupon_code}}{{ $t('appliedmnth') }}</p>
									</div> 
								</div> -->
								<a class="haveacode" v-else href="#" v-on:click.prevent="show_coupon_list=true; getcouponList() ; coupon_code_validity = ''">{{ $t('havePromoCode') }}</a> 
							</div>
						</div> 
						<div class="whitebox">
							<p class="mb-3 text-center">{{$t('googleAuth1')}} <strong>{{$t('googleAuth2')}}</strong> {{$t('googleAuth3')}}. </p>
							<div class="form-group field-wrapper">
								<input type="text" placeholder="000 000" class="mdb-select md-form form-control" v-model="otp" v-validate="{ required: true, max: 6,numeric : true }" name="OTP"  :class="{ 'is-invalid': submittedOtp && errors.has('OTP') }" ref="otpInput">
								<ul><li v-for="error in errors.collect('OTP')">{{ error }}</li></ul>
							</div> 
							<div class="form-group text-center field-wrapper">
								<button class="prism_btn btn_sm " v-on:click="submitChangeLeverageCheckOtp()">{{$t('validate')}} </button>
							</div>
							<div class="clearfix"></div>
							<div class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"> 
								<div class="desc text-center">
									<p>{{$t('googleAuth4')}} <a v-on:click="resendLink()" href="#"><strong>{{$t('googleAuth5')}}</strong></a></p>
								</div>
							</div>
							<div class="clearfix"></div>
						</div> 
					</div>
					<div class="middleBox1"  v-if="(parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent)">
						<div class="congratulations">
							<div class="logo_congrats">
								<img src="../../../../static/fxView/images/leverage.svg" alt="Icon">
							</div>
							<div class="subtitle">
								<p class="mb-3">{{$t('dear')}} <strong class="green">{{get_user.username}}</strong>
									{{$t('googleAuth6')}} <strong>{{get_user.email}} . </strong>  {{ $t('linkToSub') }}
								</p>
								<a v-on:click="resendLink()" href="#" class="mb-3"><strong>{{$t('googleAuth7')}}</strong></a>
							</div>
						</div>
						<div class="clearfix"></div>
						<div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
							<div class="ico mr-3">
								<img src="../../../../static/fxView/images/google_auth.png" alt="2fa">
							</div>
							<div class="desc w-75">
								<h5 class="mb-2"><strong>{{$t('googleAuth8')}}</strong></h5>
								<p>{{$t('googleAuth9')}} <a v-on:click="authComponent = true" href="#"><strong>{{$t('googleAuth10')}}</strong></a></p>
							</div>
						</div>
					</div>
				</div>
				<!---------------------congo-message-------------->
				<div class="CustomBlockWidth whitebox mb-3 inMiddle-area p-4 stepForm" v-if="congModuleLev">
					<div class="congratulations">
						<div class="logo_congrats">
							<img src="../../../../static/fxView/images/check.svg" alt="Icon">
						</div>
						<div class="subtitle">
							<h3>{{$t('congo')}} <span class="green">{{get_user.username}}</span></h3>
							<p>{{subPlanDetail[0].plan_type}} {{ $t('subsucce') }}</p> 
						</div>
						<div class="signupbtn full-width submitButton w-100 mt-4 text-center">
							<router-link :to="'/auto-chartist'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 1"> {{ $t('AutoChartPage') }}</router-link>
							<router-link :to="'/signal-centre'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 2"> {{ $t('controlsignalPage') }}</router-link>
							<router-link :to="'/economic-calendar'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 4"> {{ $t('researchReportpage') }}</router-link>
							<router-link :to="'/trade-news'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 3"> {{ $t('currentNewsPage') }}</router-link>
							<router-link :to="'/economic-calendar'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 5"> {{ $t('economicCalPage') }}</router-link>
							<router-link :to="'/vps-list'" class="prism_btn btn_sm" v-if="$route.query.plan_id == 6">{{ $t('vpsPage') }}</router-link>
						</div>
					</div> 
				</div>
				 
				<!-----------------------------section display when i click on have a  promocode-------------------------->
				<section class="costompopup pop_sm1" v-if="show_coupon_list">
					<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
					<div class="middleBox  platfromBox"> 
						<div class="darkBG platfromBox_title p-3">  
							<h4 class="mb-0">{{ $t('selectPromoCode') }}</h4>
							<feather class="close" v-on:click="show_coupon_list = false" type="x"></feather>
						</div>
						<div class="p-4">
							<div class="row">
								<div class="col-12 col-md-8">
									<input type="text" :placeholder="$t('EnterCouponCode')" v-model="coupon_code_validity" class="form-control">		
								</div>
								<div class="col-12 col-md-4">
									<button class="prism_btn btn_sm w-100" @click="checkCouponCode()" :class="(coupon_code_validity == '')? 'disabled' : ''"> {{ $t('Apply') }}</button>
								</div>
							</div>
						</div> 
						<div class="couponDesc scrollbar" > 
							<div v-if="couponList.length > 0">
								<div class="selectPro d-flex align-items-center justify-content-between p-3 border-top " v-for="coupon in couponList ">
									<div class="desc">
										<strong class="green">{{coupon.code}}</strong>
										<p class="description">{{coupon.description}} {{ $t('For') }}  {{coupon.period}} </p>
									</div>
									<button class="prism_btn btn_sm" @click="applycoupon(coupon,'apply')" v-if="!couponapplied">{{ $t('Apply') }}</button>
								</div>
							</div>
							<div class="p-5 border-top text-center" v-else>
								<p class="red">{{$t('noPromoCode')}}</p>
							</div>
						</div>
						
					</div>
				</section> 
				<!------------------------------------------------------------------------------------------------------------>
			</div>
		</div>
		<div class="partcipate-fund CustomBlockWidth inMiddle-area mb-3" v-if="parseInt(get_user.profile.total_deposit) == 0">
			<div class="mainTitle text-center mt-4 mb-3">
				<h3 class="mb-4">{{$t('vpsSubPlan')}}</h3>
			</div>
			<div class="whitebox text-center p-4 mb-3">  
				<img src="../../../../static/fxView/images/fund_deposit.svg" alt="add fund" class="mb-3" width="250">
				<p class="mb-2">{{$t('createVPS')}}</p>
				<router-link to="/deposit" class="prism_btn btn_sm"  data-placement="top"  data-toggle="tooltip">
					{{$t('goDepositPage')}}
				</router-link> 
			</div>
		</div>
		
		<div class="text-center CustomBlockWidth">
			<router-link :to="{name: 'fxView.subscription_service_plan' , query: { 'id':$route.query.plan_id}}" class="underline" title="subscribe" data-placement="top"  data-toggle="tooltip">
				 {{ $t('backSub') }}
			</router-link>
		</div> 
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import twoFa from '../users/2FA'
    export default {
        name: 'Create-Subscription-Ticket',
        mixins: [fxViewMixins],
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                //==========================================
                come_from_manage_page : false,
                exsisting_leverage : '',
				coupon_code_validity : '',
                account_id_leverage : '',
                submitted : false,
				//-----select account----
				selectAccount : false,
                account_id : '',
				act_account_id : '',
				demo_live : '',
				platform :'', 
				//------------------------
                otp : '',
                submittedOtp : false,
                transaction_id : '',

                congModuleLev : false,
                authComponent : false,
                request_page : 'accounts',
                show_coupon_list: false,
                coupon_code: -1,
				counpon_price2 : '',
                couponapplied: false,
                amount: 0,
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				planDetailData : '',
				
				
				coupon_apply : false,
				coupon_code1 : -1,
				coupon_price : '',
				agree1 : ''
            }
        },
        methods:{
			asignValueParentComponent(list){
				this.account_id = list.account_id 
				this.act_account_id = list.act_account_id  
				this.demo_live = list.demo_live 
				this.platform = list.platform 
		    },
			reset(){
                this.selectAccount = false,
                this.account_id = ''
				this.act_account_id = ''
				this.demo_live = ''
				this.platform =''
                this.submitted = false
            },
			
			submitChangeLeverageRequestOtp(){
				const _that = this
				this.submitted = true
				let coupon_code = -1
				if(this.coupon_apply){
					coupon_code = this.coupon_code1
				}else if(this.couponapplied){
					coupon_code = this.coupon_code
				}
				_that.$validator.validate().then(valid => {
                    if (valid) {
						let input_json={
							'globalParams' :{
								'account_id' : _that.account_id ,
								"act_account_id" : _that.act_account_id,
								"plan_id" : _that.$route.query.plan_id,
								"detail_id" : _that.planDetailData.id,
								'operation' : _that.subPlanDetail[0].plan_type,
								"couponcode": coupon_code
							},
							'localParams' :{ "parameter" : _that }
						}
						_that._runSubOperation(input_json)
					}
				})
            },
            submitChangeLeverageCheckOtp(){
                const _that = this
                this.submittedOtp = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'google_token' : _that.otp.toString() ,
                                'trans_id' : _that.transaction_id.toString()
                            },
                            'localParams' :{ "parameter" : _that , "plan_id" : _that.$route.query.plan_id,"detail_id" : _that.planDetailData.id, }
                        }
                        _that._runCreateSubTicket(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
			resendLink(){
                let input_json = {
                    'globalParams' : {
                        'trans_id' : this.transaction_id.toString()
                    } ,'localParams' : {'parameter' : this}
                }
                this._runSubOperLink(input_json)
            },
			
			
			//when click on have a promocode
            getcouponList(){
                // RUN_GET_COUPON_LIST
                const _that = this
                let input_json={
                    'globalParams' :{
                        "plan_id" : _that.$route.query.plan_id
                    },
                    'localParams' :{ "parameter" : _that }
                }
                _that._runGetCouponList(input_json)
            },
			checkCouponCode(){
				let input_json={
                    'globalParams' :{
                        "coupon_code" : this.coupon_code_validity
                    },
                    'localParams' :{ "parameter" : this }
                }
                this._runCheckCouponValidity(input_json)
			},
			applycoupon(couponlist,getData){
				if(getData == 'apply'){
					this.coupon_code = couponlist.code
					this.counpon_price2 = couponlist.discount_amount
					if(parseInt(couponlist.is_fixed)){
						this.amount = this.amount - couponlist.discount_amount
					}else{
						this.amount = this.amount - ((this.amount * couponlist.discount_amount)/100)
					}
					this.couponapplied = true
					this.show_coupon_list= false
				}else{
					this.couponapplied = false
					this.amount = this.planDetailData.amount
				}
				
            },
			
            
			userDepositFunc(){
				this.detailPLanCoupon()
			},
			detailPLanCoupon(){
				let input_json={
					'globalParams' :{
						'plan_id' : this.planDetailData.id ,
					},
					'localParams' :{ "parameter" : this }
				}
				this._runCouponPlan(input_json)
			},
        },
        components: {
            appTwofa: twoFa
        },
        created(){
			let input_json={
				'globalParams' :{
					'plan_id' : this.$route.query.plan_id
				},
				'localParams' :{ "parameter" : this , 'plan_detail_id' : this.$route.query.plan_detail_id , 'page' : 'create_plan_ticket'}
			}
			this._runGetSubPlanDetail(input_json)
        },
		mounted() { 
			const _that = this
            $(document).on("click", function(event){
				if(!$(event.target).closest('.SelectAcntList').length){
                    _that.selectAccount = false
                }
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/tradingtools/createSubTicket.vue